import React from 'react';
import styled from 'styled-components';
import { lightGrey2Color } from 'js/config/style';

export default styled(({ disabled, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
    <path
      className="lines"
      d="M23,6 L1,6 C0.45,6 0,5.55 0,5 C0,4.45 0.45,4 1,4 L23,4 C23.55,4 24,4.45 24,5 C24,5.55 23.55,6 23,6 Z M23,13 L1,13 C0.45,13 0,12.55 0,12 C0,11.45 0.45,11 1,11 L23,11 C23.55,11 24,11.45 24,12 C24,12.55 23.55,13 23,13 Z M23,20 L1,20 C0.45,20 0,19.55 0,19 C0,18.45 0.45,18 1,18 L23,18 C23.55,18 24,18.45 24,19 C24,19.55 23.55,20 23,20 Z"
      fillRule="nonzero"
    />
  </svg>
))`
  position: relative;
  width: 24px;
  height: 24px;

  .lines {
    fill: ${({ color, disabled }) => (color ? color : disabled ? lightGrey2Color : '#0875e3')};
  }
`;
